import React from 'react';
import { useNavigate } from 'react-router-dom';

const badges = [
  { icon: '🛡️', title: 'ISO 27001', desc: 'Informasjonssikkerhet sertifisert', color: '#004F98' },
  { icon: '🇳🇴', title: 'Norsk GDPR', desc: 'Datatilsynet-godkjent', color: '#FF5722' },
  { icon: '🔐', title: 'SSL/TLS 1.3', desc: 'Ende-til-ende kryptering', color: '#004F98' },
  { icon: '✅', title: 'Vegvesenet', desc: 'Offisielt partnerskap', color: '#FF5722' },
];

const testimonials = [
  { name: 'Kari Nordmann', role: 'Daglig leder, TransportAS', text: 'Veiassistent har spart oss for over 80 000 kr i bomutgifter det siste året. Uunnværlig for vår flåte.' },
  { name: 'Erik Olsen', role: 'Privatsjåfør, Oslo', text: 'Endelig en app som faktisk beregner EV-rabattene riktig. Anbefaler til alle elbileiere!' },
];

const TrustSection = () => {
  const navigate = useNavigate();
  return (
    <section className="trust-section-padding" style={{ position: 'relative', padding: '120px 48px', background: 'rgba(0,79,152,0.03)', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '2px', background: 'linear-gradient(to right, transparent, rgba(0,79,152,0.3), transparent)' }} />
      <div style={{ position: 'absolute', top: '30%', left: '-100px', width: '400px', height: '400px', border: '1px solid rgba(0,79,152,0.06)', transform: 'rotate(20deg)', pointerEvents: 'none' }} />
      <div style={{ maxWidth: '1440px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <div style={{ display: 'inline-block', background: 'rgba(0,79,152,0.1)', border: '1px solid rgba(0,79,152,0.2)', borderRadius: '2px', padding: '4px 12px', marginBottom: '20px' }}>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#004F98' }}>Sikkerhet & tillit</span>
          </div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 700, color: 'var(--color-foreground)', lineHeight: 1.1, letterSpacing: '-0.01em', marginBottom: '16px' }}>Betrodd av 50 000+
            <span style={{ display: 'block', color: '#004F98' }}>norske sjåfører</span>
          </h2>
        </div>

        {/* Badges */}
        <div className="trust-badges-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px', marginBottom: '80px' }}>
          {badges?.map((b, i) => (
            <div
              key={b?.title}
              className="trust-badge-offset"
              style={{
                position: 'relative',
                padding: '28px 24px',
                background: 'rgba(255,255,255,0.03)',
                border: `2px solid ${b?.color}22`,
                borderRadius: '2px',
                textAlign: 'center',
                marginTop: i % 2 === 1 ? '20px' : '0',
              }}
            >
              <div style={{ position: 'absolute', top: '-1px', left: '-1px', width: '20px', height: '20px', borderTop: `3px solid ${b?.color}`, borderLeft: `3px solid ${b?.color}` }} />
              <div style={{ position: 'absolute', bottom: '-1px', right: '-1px', width: '20px', height: '20px', borderBottom: `3px solid ${b?.color}`, borderRight: `3px solid ${b?.color}` }} />
              <div style={{ fontSize: '32px', marginBottom: '12px' }}>{b?.icon}</div>
              <div style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 700, color: b?.color, marginBottom: '6px', letterSpacing: '0.04em' }}>{b?.title}</div>
              <div style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: 'var(--color-muted-foreground)' }}>{b?.desc}</div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="trust-testimonials-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', marginBottom: '80px' }}>
          {testimonials?.map((t, i) => (
            <div
              key={t?.name}
              className="trust-testimonial-offset"
              style={{
                padding: '36px 32px',
                background: 'rgba(255,255,255,0.02)',
                border: '1px solid rgba(224,228,232,0.08)',
                borderRadius: '2px',
                position: 'relative',
                marginTop: i === 1 ? '24px' : '0',
              }}
            >
              <div style={{ position: 'absolute', top: '24px', left: '32px', fontFamily: 'Georgia, serif', fontSize: '60px', color: 'rgba(255,87,34,0.15)', lineHeight: 1, userSelect: 'none' }}>"</div>
              <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', fontWeight: 500, color: 'var(--color-foreground)', lineHeight: 1.7, marginBottom: '24px', paddingTop: '20px', position: 'relative', zIndex: 1 }}>{t?.text}</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ width: '40px', height: '40px', background: 'rgba(255,87,34,0.15)', border: '2px solid rgba(255,87,34,0.3)', borderRadius: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <span style={{ fontFamily: 'var(--font-heading)', fontSize: '16px', fontWeight: 700, color: '#FF5722' }}>{t?.name?.[0]}</span>
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 700, color: 'var(--color-foreground)' }}>{t?.name}</div>
                  <div style={{ fontFamily: 'var(--font-caption)', fontSize: '12px', color: 'var(--color-muted-foreground)' }}>{t?.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="trust-cta-banner" style={{ position: 'relative', padding: '60px 64px', background: 'rgba(255,87,34,0.06)', border: '2px solid rgba(255,87,34,0.2)', borderRadius: '2px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '40px', flexWrap: 'wrap', overflow: 'hidden' }}>
          <div style={{ position: 'absolute', top: '-40px', right: '-40px', width: '200px', height: '200px', border: '2px solid rgba(255,87,34,0.1)', transform: 'rotate(15deg)', pointerEvents: 'none' }} />
          <div style={{ position: 'absolute', top: '-1px', left: '-1px', width: '40px', height: '40px', borderTop: '4px solid #FF5722', borderLeft: '4px solid #FF5722' }} />
          <div>
            <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(22px, 3vw, 32px)', fontWeight: 700, color: 'var(--color-foreground)', marginBottom: '8px', letterSpacing: '-0.01em' }}>Klar til å spare penger?</h3>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', color: 'var(--color-muted-foreground)', lineHeight: 1.6 }}>Registrer deg gratis i dag — ingen kredittkort kreves.</p>
          </div>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
            <button
              onClick={() => navigate('/register')}
              style={{ background: '#FF5722', border: '2px solid #FF5722', borderRadius: '2px', padding: '18px 40px', fontFamily: 'var(--font-heading)', fontSize: '15px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#FFFFFF', cursor: 'pointer' }}
            >
              Registrer deg nå
            </button>
            <button
              onClick={() => navigate('/trust-and-security')}
              style={{ background: 'transparent', border: '2px solid rgba(224,228,232,0.2)', borderRadius: '2px', padding: '18px 40px', fontFamily: 'var(--font-heading)', fontSize: '14px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--color-foreground)', cursor: 'pointer' }}
            >
              Les om sikkerhet
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
